import { Box,Button,Flex,Select,InputGroup,UnorderedList, ListItem,
  InputLeftElement,Input, Heading, Text, Switch,
  TableContainer,Table,Thead,Tbody,Th,Tr,Td, GridItem, Image, Textarea, 
  Link} from "@chakra-ui/react";
  import { FaRegFile as FileIcon,FaTimes as CancelIcon } from "react-icons/fa";
import { TopDisplay,UploadButton } from "../../../components";
import { BsDownload as DownloadIcon } from "react-icons/bs";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState ,useEffect} from "react";
// import styled from "@emotion/styled";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { Formik,Form,Field } from "formik";
import {TablePopUp} from '../../../components';
import { MdMoreVert as MoreIcon } from "react-icons/md";
import { Loader } from "../../../customs";
import { FcInvite as InviteIcon} from "react-icons/fc";
import apiCall from '../../../utils/apiCall';
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';
import { useDropzone } from 'react-dropzone';
import apiCallFormData from '../../../utils/apiFormDataCall';
import { BsUpload as UploadIcon} from "react-icons/bs";
import {
  Grid,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
} from '@chakra-ui/react'
import {useAtom,atom} from 'jotai'
import { modalAtom, openAtom, notificationAtom, openNAtom } from "../../../context";
import { format } from "date-fns";
import * as Yup from 'yup';
import styled from "@emotion/styled";



const src=`/public-assets/upload_icon.png`;

const indexAtom = atom<number | null>(null);
const list = [
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
  thcolor:'var(--dark-green-color)'
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type{
    width:50px;
    height:63px;
    & > div{
      display:none;
    }
  }
  &:hover > *{
    cursor: pointer;
    background-color:var(--table-highlight);
  } 
  & > td{
    width:140px;
  }
  &:hover > td:last-of-type{
    
    & > div{
      display: block;
    }
  }
  & > td > div.active{
    display: block;
  }
`

export default function UploadPayment() {
  const [hide,set_hide] = useState<boolean>(true);
  const [activeIndex] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const [selected_status,set_selected_status] = useState<null | string>(null);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);
   const {data:subscription,isLoading} = useQuery(['all-induction'],{
    queryFn:async()=>await apiCall().get(`/MembershipSetUp/member/GetAllPendingSubscriptionInvoiceForStudent?hasPaid=true`),
    select(data:any){
     // console.log(data,'Subscription')
    return data?.data?.Data;
    }
  });
  // const { data: subscription, isLoading } = useQuery(
  //   ['all-induction'],
  //   async () =>
  //     await apiCall().get(
  //       `/MembershipSetUp/member/GetAllPendingSubscriptionInvoiceForStudent?hasPaid=true`
  //     ),
  //   {
  //     select(data: any) {
  //       return data?.data?.Data; // assuming this is an array of all results
  //     },
  //   }
  // );
  const [search,set_search] = useState('');

  const handleSearch = (e:any)=>{
    let val = e.target.value;
    set_search(val);
    if(val){
      let new_data = filter_data?.filter((eData:any) => Object.values(eData).join('').toLowerCase().includes(val.toLowerCase()) );
      if(new_data.length > 0)set_filter_data(new_data)
      else set_filter_data(subscription)
    }
    else set_filter_data(subscription)
  }


  const [filter_data,set_filter_data] = useState<any>(subscription);

  const itemsPerPage = 120;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);
  

  const handlePageClick = (event:any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };

    const {mutate:handleDownload,isLoading:loadingDownload} = useMutation({
      mutationKey:[],
      mutationFn:async ()=> {
        const headers = {
          "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        };
        return await apiCall().get(`/Member/downloadPaymentSubscriptionTemplate`,{
          headers,
          responseType:"blob"

        })},
      onSuccess:async(data:any)=>{
        //initial the download 
        //console.log(data,'download data')
        let file = data?.data;
        //console.log(file,'download file');
        if(file){
          const url = window.URL.createObjectURL(new Blob([file]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "subscription-template.xlsx");
          document.body.appendChild(link);
          link.click();
          //console.log(file,'data')
          set_notification({
            type:'success',
            message:data?.data?.Message || 'Subscription Template downloaded Successfully'
          })
          set_Nopen(true);
        }
        else{
          set_notification({
            type:'error',
            message:'Oooops! Error Occured trying to download file'
          })
          set_Nopen(true);
        }
        
        
        
      },
      onError(error:any, variables, context) {
        set_notification({
          type:'error',
          message:error?.data?.Message || 'Error Occured'
        })
        set_Nopen(true);
      },
      onSettled:()=>{
        set_open(false);
      }

    } )
  
  const showUploadPaymentSubscription = () =>{
    set_modal({
      header:'Upload Subscription payment',
      content:<UploadPaymentSubscription />
    })
    set_open(true);
  }
  const showDownloadTemplate = () =>{
    handleDownload();
  }

  useEffect(()=>{
    //console.log(selected_status,'s_status')
    if(selected_status){
      let data = subscription.filter((eData:any) => eData.Status.toLowerCase().trim().includes(selected_status.toLowerCase().trim()));
      if(data.length > 0){
        set_filter_data(data);
      }
    }
    else{
      set_filter_data(subscription);
    }
  },[selected_status])

  useEffect(()=>{
    set_filter_data(subscription)
  },[subscription])

  return (
    <>
   {isLoading?<Loader />:

    <Box>
      <TopDisplay label="Upload Payment Subscription" button_array={[
          <Button  bg="var(--dark-green-color)" color="var(--white-color)"   leftIcon={<UploadIcon/>}    variant="outline"
            colorScheme="var(--dark-green-color)"
            onClick={showUploadPaymentSubscription}
          >Upload Subscription Payment</Button>,
          <Button variant="outline"  bg="var(--white-color)" color="var(--darek-green-color)"  leftIcon={<DownloadIcon/>}  
          colorScheme="var(--dark-green-color)" disabled={loadingDownload}
          onClick={showDownloadTemplate}
        >{loadingDownload?'Loading':'Download Upload Template'}</Button>,
         
        ]} />
        <Flex  gap="20px" wrap="wrap" mt="20px">
          <InputGroup h="40px" width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
            <InputLeftElement pointerEvents='none'>
              <SearchIcon color='gray.300' />
            </InputLeftElement>
            <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
            <span style={{position:'absolute',zIndex:'1',
            right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
          </InputGroup>
        </Flex>
        <Flex mt="25px" flexDir="column" gap="10px">
          <Heading m="0" fontSize="1rem">All Payment Upload</Heading>
          <Text m="0" fontSize=".8rem">Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
        </Flex>
     {  filter_data && filter_data.length > 0 ? <TableContainer mt="20px">
          <Table size='sm'>
            <Thead>
            <Tr >
              <Th sx={HeadStyle}>Name</Th>
              <Th sx={HeadStyle}>Membership-Type</Th>
              <Th sx={HeadStyle}>MembershipNo</Th>
              {/* <Th sx={HeadStyle}>Amount</Th> */}
              <Th sx={HeadStyle}>Outstanding</Th>
              {/* <Th sx={HeadStyle}>RoutId</Th> */}
                <Th sx={HeadStyle}>Due-year</Th>
                <Th sx={HeadStyle} w="50px"></Th>
              </Tr>
            </Thead>
            <Tbody>
            {currentItems.map((eCandidate:any,index:number) =><ROWSTYLE key={index}>
              <Td sx={DataStyle}>{eCandidate.Name}</Td>
                <Td sx={DataStyle}>{eCandidate.MembershipType}</Td>
                <Td sx={DataStyle}>{eCandidate.MembershipNo}</Td>
                {/* <Td sx={DataStyle}>{eCandidate.Level?.Amount}</Td> */}
                <Td sx={DataStyle}>{eCandidate.OutstandingAmount}</Td>
                {/* <Td sx={DataStyle}>{eCandidate.RouteId}</Td> */}
                 <Td sx={DataStyle}>{eCandidate.DueYear}</Td>
                <Td sx={DataStyle} minW="60px" w="50px" h="50px">
                    <div className={activeIndex === index?'active':''}><Option {...{index,candidate:eCandidate}}/></div>
                </Td>
              </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :'No uploads'  
      }
      <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>

    </Box>
}
</>
  )
}
const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const sx={
  ':hover':{
    bg:'var(--content-background)'
  }
}

const Option = (props:any)=>{
  const index = props.index;
  const candidate= props.candidate;
  const [ind,set_index] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom)
  const onClick=()=>{
    if(index === ind){
      set_index(null);
      return;
    }
    set_index(index);
  }
  const handleShowProfile = () =>{
    set_index(null);
    set_modal({
      header:'View Details',
      content:<ViewProfile candidate={candidate} />
    })
    set_open(true);
  }
  useEffect(()=>{
    return ()=>set_index(null)
  },[])
  return(
    <Popover>
    <PopoverTrigger>
      <Button onClick={onClick} bg="var(--cipm-light-green)"><MoreIcon /></Button>
    </PopoverTrigger>
    <PopoverContent width="fit-content">
      <PopoverArrow />
      <PopoverBody>
        <Grid templateColumns="1fr" p="6px">
          <GridItem sx={sx} p="8px 4px" onClick={handleShowProfile}>View Details</GridItem>
          {/* <GridItem sx={sx} p="8px 4px">View Details</GridItem> */}
        </Grid>
      </PopoverBody>
    </PopoverContent>
  </Popover>
  )
}

const ViewProfile = (props:any) =>{
  return(
  <Flex flexDir="column" minWidth="600px" gap="50px">
    <Flex align="center" gap="20px">
      {/* <Image
        src="/public-assets/profile.png"
        width="150px"
        height="150px"
        objectFit="contain"
        objectPosition="center"
        alt="profile"
      /> */}
      <Flex gap="20px">
        {/* <Heading fontSize="1rem">{props.candidate.FirstName+" "+props.candidate.LastName}</Heading> */}
        <Text width="150px"  fontWeight="500" color="var(--light-text)">Name</Text>
        <Text> {props.candidate.Name}</Text>
      </Flex>
    </Flex>
    <Grid templateColumns="1fr" templateRows="repeat(3,1fr)" gap="30px">
     
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">MembershipType</Text>
        <Text fontWeight="500">{props.candidate.MembershipType || 'N/A'}</Text>
      </GridItem>
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">MembershipNo</Text>
        <Text fontWeight="500">
          {props.candidate.MembershipNo || 'N/A'}
        </Text>
      </GridItem >
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">Amount</Text>
        <Text fontWeight="500">
          {props.candidate.Amount || 'N/A'}
        </Text>
      </GridItem >
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">RoutId</Text>
        <Text fontWeight="500">
          {props.candidate.RouteId  || 'N/A'}
        </Text>
      </GridItem >
      {/* <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">Date</Text>
        <Text fontWeight="500">{format(new Date(props.eCandidate.PaymentDate), "dd/MM/yyyy")}
        </Text>
      </GridItem > */}
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">Due Year</Text>
        <Text fontWeight="500">
          {props.candidate.DueYear||'N/A'}
        </Text>
      </GridItem >
      {/* <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">Outstanding</Text>
        <Text fontWeight="500">
          {props.candidate.OutstandingAmount || 'N/A'}
        </Text>
      </GridItem >
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">Status</Text>
        <Text fontWeight="500">
          {props.candidate.PaymentStatus || 'N/A'}
        </Text>
      </GridItem > */}
    </Grid>
  </Flex>
  )}

  const Label = styled.label``;  

const UploadSchema = Yup.object({
  StudentSubscriptionPayment:Yup.mixed()

});
  
  
// const UploadPaymentSubscription = (props: any) => {
//   const queryClient = useQueryClient();
//   const [, set_open] = useAtom(openAtom);
//   const [, set_Nopen] = useAtom(openNAtom);
//   const [, set_notification] = useAtom(notificationAtom);

//   const [uploadedFiles, setUploadedFiles] = useState<any>([]);
//   const [uploadedFileUrl, setUploadedFileUrl] = useState<string | null>(null);
//   const [errorMessage, setErrorMessage] = useState<string | null>(null);

//   const { getRootProps, getInputProps } = useDropzone({
//     onDrop: (acceptedFiles) => {
//       console.log(acceptedFiles, 'files');
//       setUploadedFiles(acceptedFiles);
//     },
//   });

//   const removeFile = (name: any) => {
//     setUploadedFiles((files: any[]) => files?.filter(eFile => eFile.name !== name));
//     setUploadedFileUrl(null); 
//     setErrorMessage(null); 
//   };

//   // const { mutate: addUpdate, isLoading } = useMutation({
//   //   mutationKey: ['upload-payment'],
//   //   mutationFn: async (data: FormData) => {
//   //     return await apiCallFormData().post(`/Member/UploadPaymentSubscription`, data);
//   //   },
//   //   onSuccess: (data) => {
//   //     const response = data?.data;
      
//   //     if (response?.StatusCode === 200 && response?.Message?.toLowerCase().includes("error")) {
      
//   //       setErrorMessage(response.Message);
//   //       set_notification({
//   //         type: 'error',
//   //         message: response.Message,
//   //       });
//   //       set_Nopen(true);
//   //       return;
//   //     }

//   //     // Success Case
//   //     const fileUrl = response?.fileUrl || null; // Assuming API returns file URL
//   //     setUploadedFileUrl(fileUrl);
//   //     setErrorMessage(null); // Clear previous errors

//   //     set_notification({
//   //       type: 'success',
//   //       message: response?.Message || 'Payment Uploaded Successfully',
//   //     });
//   //     set_Nopen(true);
//   //     queryClient.invalidateQueries({ queryKey: ['upload-payment'] });
//   //     setUploadedFiles([]);
//   //   },
//   //   onError: (error: any) => {
//   //     // Handle unexpected API failures
//   //     const message =
//   //       error?.response?.data?.Message || 
//   //       error?.response?.data?.message || 
//   //       error?.message || 
//   //       'An unknown error occurred';

//   //     setErrorMessage(message);

//   //     set_notification({
//   //       type: 'error',
//   //       message: message,
//   //     });
//   //     set_Nopen(true);
//   //   },
//   //   onSettled: () => {
//   //     set_open(false);
//   //   },
//   // });
//   // const { mutate: addUpdate, isLoading } = useMutation({
//   //   mutationKey: ['upload-payment'],
//   //   mutationFn: async (data: FormData) => {
//   //     return await apiCallFormData().post(`/ExamUpload/uploadStudentSubscriptionPayment`, data);
//   //   },
//   //   onSuccess: (data) => {
//   //     const response = data?.data;
      
//   //     if (response?.StatusCode === 200 && response?.Message?.toLowerCase().includes("error")) {
      
//   //       setErrorMessage(response.Message);
//   //       set_notification({
//   //         type: 'error',
//   //         message: response.Message,
//   //       });
//   //       set_Nopen(true);
//   //       return;
//   //     }

//   //     // Success Case
//   //     const fileUrl = response?.fileUrl || null; // Assuming API returns file URL
//   //     setUploadedFileUrl(fileUrl);
//   //     setErrorMessage(null); // Clear previous errors

//   //     set_notification({
//   //       type: 'success',
//   //       message: response?.Message || 'Payment Uploaded Successfully',
//   //     });
//   //     set_Nopen(true);
//   //     queryClient.invalidateQueries({ queryKey: ['upload-payment'] });
//   //     setUploadedFiles([]);
//   //   },
//   //   onError: (error: any) => {
//   //     // Handle unexpected API failures
//   //     const message =
//   //       error?.response?.data?.Message || 
//   //       error?.response?.data?.message || 
//   //       error?.message || 
//   //       'An unknown error occurred';

//   //     setErrorMessage(message);

//   //     set_notification({
//   //       type: 'error',
//   //       message: message,
//   //     });
//   //     set_Nopen(true);
//   //   },
//   //   onSettled: () => {
//   //     set_open(false);
//   //   },
//   // });
 
  
//   return (
//     <>
//       <Formik
//         initialValues={{ StudentSubscriptionPayment: props.StudentSubscriptionPayment || '' }}
//         validationSchema={UploadSchema}
//         onSubmit={(values: any) => {
//           if (uploadedFiles.length > 0) {
//             const data = new FormData();
//             data.append('StudentSubscriptionPayment', uploadedFiles[0]);
//             // data.append('MembershipType', '4');
//             addUpdate(data);
//           } else {
//             set_notification({
//               type: 'error',
//               message: 'Select a file',
//             });
//             set_Nopen(true);
//             return;
//           }
//         }}
//       >
//         {(formik: any) => {
//           const { errors } = formik;
//           return (
//             <Form>
//               <Flex flexDir={"column"} align={"center"} gap="20px">
//                 <Flex flexDir="column" gap="10px" w="100%">
//                   <Box>Upload Document:<br/></Box>
//                   <Box {...getRootProps()}>
//                     <input {...getInputProps()} name="PaymentSubscription" id="file" />
//                     <Image
//                       alt="upload document"
//                       src={src}
//                       w="100%"
//                       h="150px"
//                       objectFit="contain"
//                       objectPosition="center"
//                     />
//                     <UnorderedList sx={{ p: '0', m: '0', 'listStyleType': 'none' }}>
//                       {uploadedFiles?.slice(0, 1).map((file: any) => (
//                         <ListItem align="center" gap="10px" as={Flex} sx={{ p: '5px 0' }} fontSize="11px" key={file.name}>
//                           <FileIcon />{file.name}
//                           <CancelIcon style={{ marginLeft: 'auto' }} onClick={() => removeFile(file.name)} />
//                         </ListItem>
//                       ))}
//                     </UnorderedList>
//                   </Box>
//                 </Flex>

//                 {/* Display uploaded file link if available */}
//                 {uploadedFileUrl && (
//                   <Box mt={2}>
//                     <Text color="green.500">File uploaded successfully:</Text>
//                     <Link href={uploadedFileUrl} isExternal color="blue.500">
//                       View Uploaded File
//                     </Link>
//                   </Box>
//                 )}

//                 {/* Display error message if upload fails */}
//                 {errorMessage && (
//                   <Box color="red.500" mt={2} fontSize="14px">
//                     ❌ {errorMessage}
//                   </Box>
//                 )}

//                 <Box>
//                   {errors && Object.values(errors).map((eError: any, index: number) => (
//                     <Box color="red" key={index}>{eError}</Box>
//                   ))}
//                 </Box>

//                 <Button type="submit" bg="var(--dark-green-color)" color="var(--white-color)" disabled={isLoading}>
//                   {isLoading ? "Loading" : 'Submit'}
//                 </Button>
//               </Flex>
//             </Form>
//           );
//         }}
//       </Formik>
//     </>
//   );
// };

 const UploadPaymentSubscription = (props: any) => {
    const queryClient = useQueryClient();
    const [, set_open] = useAtom(openAtom);
    const [, set_Nopen] = useAtom(openNAtom);
    const [, set_notification] = useAtom(notificationAtom);
    const [uploadedFiles, setUploadedFiles] = useState<any[]>([]);
  
    const { getRootProps, getInputProps } = useDropzone({
      onDrop: (acceptedFiles) => {
        setUploadedFiles(acceptedFiles);
      },
    });
  
    const removeFile = (name: any) => {
      setUploadedFiles((files: any[]) => files.filter((file) => file.name !== name));
    };
  
    const { mutate: addUpdate, isLoading } = useMutation({
      mutationKey: ["student-subscription-payment"],
      mutationFn: async (data: FormData) => {
        return await apiCallFormData().post(`/ExamUpload/uploadStudentSubscriptionPayment`, data, {
          responseType: "blob", // Ensures we properly handle file responses
        });
      },
      onSuccess: (response, variables, context) => {
        const contentType = response.headers["content-type"];
        if (contentType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
          const blob = new Blob([response.data], { type: contentType });
          const contentDisposition = response.headers["content-disposition"];
          const filenameMatch = contentDisposition?.match(/filename="(.+)"/) || contentDisposition?.match(/filename\*=UTF-8''(.+)/);
          const filename = filenameMatch ? decodeURIComponent(filenameMatch[1]) : "FailedUploads.xlsx";
  
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
  
          set_notification({
            type: "error",
            message: "Some uploads failed. Download the error file for details.",
          });
        } else {
          const message = response?.data?.Message || "Subscription Payment Uploaded Successfully";
          set_notification({ type: "success", message });
        }
  
        set_Nopen(true);
        queryClient.invalidateQueries({ queryKey: ["all-subscription"] });
        setUploadedFiles([]);
      },
      onError: (error: any) => {
        set_notification({
          type: "error",
          message: error?.data?.Message || "Oops! Error Occurred",
        });
        set_Nopen(true);
      },
      onSettled: () => {
        set_open(false);
      },
    });
  
    return (
      <>
        <Formik
          initialValues={{
            StudentSubscriptionPayment: props.StudentSubscriptionPayment || "",
          }}
          validationSchema={UploadSchema}
          onSubmit={() => {
            if (uploadedFiles.length > 0) {
              const data = new FormData();
              data.append("StudentSubscriptionPayment", uploadedFiles[0]);
              addUpdate(data);
            } else {
              set_notification({
                type: "error",
                message: "Select a file",
              });
              set_Nopen(true);
            }
          }}
        >
          {(formik: any) => {
            const { errors } = formik;
            return (
              <Form>
                <Flex flexDir={"column"} align={"center"} gap="20px">
                  <Flex flexDir="column" gap="10px" w="100%">
                    <Box>Upload Student-Subscription Payment:<br/></Box>
                    <Box {...getRootProps()}>
                      <input {...getInputProps()} name="StudentSubscriptionPayment" id="file" />
                      <Image
                        alt="upload document"
                        src={src}
                        w="100%"
                        h="150px"
                        objectFit="contain"
                        objectPosition="center"
                      />
                      <UnorderedList sx={{ p: "0", m: "0", listStyleType: "none" }}>
                        {uploadedFiles?.slice(0, 1).map((file: any) => (
                          <ListItem align="center" gap="10px" as={Flex} sx={{ p: "5px 0" }} fontSize="11px" key={file.name}>
                            <FileIcon />
                            {file.name}
                            <CancelIcon style={{ marginLeft: "auto" }} onClick={() => removeFile(file.name)} />
                          </ListItem>
                        ))}
                      </UnorderedList>
                    </Box>
                  </Flex>
  
                  {errors && Object.values(errors).map((eError: any, index: number) => (
                    <Box color="red" key={index}>
                      {eError}
                    </Box>
                  ))}
  
                  <Button type="submit" bg="var(--dark-green-color)" color="var(--white-color)" disabled={isLoading}>
                    {isLoading ? "Loading" : "Submit"}
                  </Button>
                </Flex>
              </Form>
            );
          }}
        </Formik>
      </>
    );
  };


const DownloadSchema = Yup.object({

});
   
const ViewDownloadTemplate = (props:any) =>{
  // console.log({...props},'data')
  
  const [,set_open] = useAtom(openAtom);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);
  
  const {mutate:addUpdate,isLoading} = useMutation({
    mutationKey:[],
    mutationFn:async (template:string)=> {
      const headers = {
        "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      };
      return await apiCall().get(`/Member/downloadPaymentSubscriptionTemplate`,{
        headers,
        responseType:"blob"

      })},
    onSuccess:async(data:any)=>{
      //initial the download 
      //console.log(data,'download data')
      let file = data?.data;
      //console.log(file,'download file');
      if(file){
        const url = window.URL.createObjectURL(new Blob([file]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "subscription-template.xlsx");
        document.body.appendChild(link);
        link.click();
        //console.log(file,'data')
        set_notification({
          type:'success',
          message:data?.data?.Message || 'Subscription Template downloaded Successfully'
        })
        set_Nopen(true);
      }
      else{
        set_notification({
          type:'error',
          message:'Oooops! Error Occured trying to download file'
        })
        set_Nopen(true);
      }
      
      
      
    },
    onError(error:any, variables, context) {
      set_notification({
        type:'error',
        message:error?.data?.Message || 'Error Occured'
      })
      set_Nopen(true);
    },
    onSettled:()=>{
      set_open(false);
    }

  } )
  //   const {mutate:addUpdate,isLoading} = useMutation({
  //     mutationKey:[],
  //     mutationFn:async (template:string)=> {
  //       const headers = {
  //         "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  //        };
  //        return await apiCall().get(`/Member/downloadPaymentSubscriptionTemplate`,{
  //         headers,
  //          responseType:"blob"
  
  //       })},
  //   onSuccess:async(data:any)=>{
  //     //initial the download 
  //     //console.log(data,'download data')
  //     let file = data;
     
  //     if(file){
        
  //       const url = window.URL.createObjectURL(file);
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.setAttribute("download", "Subscription-template.xlsx");
  //       document.body.appendChild(link);
  //       link.click();
  //       console.log(file,'data')
  //       set_notification({
  //         type:'success',
  //         message:data?.data?.Message || 'Subscription Template downloaded Successfully'
  //       })
  //       set_Nopen(true);
  //     }
  //     else{
  //       set_notification({
  //         type:'error',
  //         message:'Oooops! Error Occured trying to download file'
  //       })
  //       set_Nopen(true);
  //     }
      
  //   },
  //   onError(error:any, variables, context) {
  //     set_notification({
  //       type:'error',
  //       message:error?.data?.Message || 'Error Occured'
  //     })
  //     set_Nopen(true);
  //   },
  //   onSettled:()=>{
  //     set_open(false);
  //   }

  // } )
  return (
    <>
      <Formik
          initialValues={{
            
            subscriptiontemplate: props.PaymentSubscription || '',
          }}
          validationSchema={DownloadSchema}
          onSubmit={(values:any) => {
              if(values.subscriptionTemplate){
                addUpdate(values.subscriptionTemplate);
              }

          }}
        >
          {(formik:any)=>{
        const {errors} = formik;
        return (
            <Form>
              <Flex flexDir={"column"} align={"center"} gap="20px">             
                  {/* <Button leftIcon={<UpIcon/>}>Upload document</Button> */}
                <Flex flexDir="column" gap="10px" w="100%">
                  {/* <Field as={Select} 
                    name="templateType"
                    placeholder="Select Template Type"
                  >
                    <option value="inductee">
                      inductee
                    </option>

                  </Field> */}
                  <Box color="red">
                    {errors && errors.subscriptionTemplate? errors.subscriptionTemplate:''}
                  </Box>
                    
                </Flex>
                {/* <Field as={Input} multiple type='file' name="Document" /> */}
                
                <Button type="submit" bg="var(--dark-green-color)" color="var(--white-color)" disabled={isLoading} >
                    {isLoading?"Loading":'Submit'}
                </Button>
              </Flex>
            </Form>
          )}}
        </Formik>
    </>
  )
}